import React, { useState } from 'react';
import './BookingBar.css';

const DatePickerModal = ({ open, onClose, onSelect, datesArr, selectedDateIdx }) => {
  const [month, setMonth] = useState(datesArr[selectedDateIdx].getMonth());
  const [year, setYear] = useState(datesArr[selectedDateIdx].getFullYear());

  if (!open) return null;

  // Получить все даты текущего месяца из datesArr
  const monthDates = datesArr.filter(d => d.getMonth() === month && d.getFullYear() === year);
  const firstDay = new Date(year, month, 1).getDay();
  const daysInMonth = new Date(year, month + 1, 0).getDate();

  return (
    <div className="payment-modal-overlay" onClick={onClose}>
      <div className="payment-modal" style={{width: 400, maxHeight: 600, overflow: 'auto'}} onClick={e => e.stopPropagation()}>
        <div className="datepicker-header">
          <button className="shift-button" onClick={()=>setMonth(m=>m-1)}>&lt;</button>
          <h3>{new Date(year, month).toLocaleString('en-US', { month: 'long', year: 'numeric' })}</h3>
          <button className="shift-button" onClick={()=>setMonth(m=>m+1)}>&gt;</button>
        </div>
        <div className="calendar-grid">
          {["Sun","Mon","Tue","Wed","Thu","Fri","Sat"].map(d=>(<div key={d} style={{fontWeight:'bold',textAlign:'center',fontSize:15}}>{d}</div>))}
          {Array(firstDay).fill(null).map((_,i)=>(<div key={'empty'+i} className="calendar-day" style={{background:'none', cursor:'default'}}></div>))}
          {Array(daysInMonth).fill(null).map((_,i)=>{
            const dateObj = new Date(year, month, i+1);
            const idx = datesArr.findIndex(d=>d.toDateString()===dateObj.toDateString());
            const isAvailable = idx !== -1;
            const isSelected = idx === selectedDateIdx;
            return (
              <div key={i} className={`calendar-day${isSelected ? ' selected' : ''}${!isAvailable ? ' disabled' : ''}`}
                style={{color:!isAvailable?'#ccc':isSelected?'#222':'#333', fontWeight:isSelected?'bold':'normal', cursor:!isAvailable?'not-allowed':'pointer', background: isSelected ? '#f3ede5' : 'none'}}
                onClick={isAvailable ? ()=>{onSelect(idx); onClose();} : undefined}
              >{i+1}</div>
            );
          })}
        </div>
      </div>
    </div>
  );
};

export default DatePickerModal; 